export default __webpack_public_path__ + "static/third-place-51b80198169de75f7f5dacccc96ca850.png";